module.exports = __webpack_public_path__ + "img/support.0601b912.png";